import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  compact,
  get,
} from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';

import { formatPrice, formatPhoneNumber } from 'helpers/utils';
import {
  injectIntl,
  PrintableTable,
} from 'components';

class PackListPrint extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
  };

  static propTypes = {
    deliveryDate: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    info: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    isPack: PropTypes.bool,

    formatMessage: PropTypes.func.isRequired,
    printHeaderChecked: PropTypes.arrayOf(PropTypes.bool).isRequired,
    checkUpdated: PropTypes.func.isRequired,
  };

  static defaultProps = {
    info: [],
    isPack: false,
  };

  getListData = (isPack) => {
    const { currentUser } = this.context;
    const { info } = this.props;
    const dataList = info.map(({ data, packrow, order, farmOrderItem, quantity }) => ({
      buyerCompanyCode: get(order, 'contact.buyerCompanyCode'),
      sellerCompanyCode: farmOrderItem ? get(farmOrderItem, 'order.contact.sellerCompanyCode') : get(order, 'contact.sellerCompanyCode'),
      buyerBusinessName: get(order, 'buyer.account.profile.companyName'),
      sellerBusinessName: get(data, 'seller.companyName') || get(order, 'contact.sellerProfile.companyName') || get(currentUser, 'account.profile.companyName'),
      itemName: `${get(data, 'productData.name')}, ${get(data, 'productData.subname')}`,
      itemTags: get(data, 'tags').join(', '),
      itemDescription: get(data, 'description'),
      itemUom: `${packrow.count} ${packrow.uom} ${packrow.pack}`,
      itemQty: quantity || 0,
      price: packrow.price || 0,
      discounted: (((packrow.price || 0) * (100 - (parseFloat(order.discount)))) / 100).toFixed(2),
      total: quantity * (
        ((packrow.price || 0) * (100 - (parseFloat(order.discount)))) / 100).toFixed(2) || 0,
      deliveryType: get(order, 'deliveryType'),
      buyerAddress: get(order, 'buyerAddress'),
      sellerAddress: get(order, 'sellerAddress'),
      buyerPhone: get(order, 'contact.buyerProfile.mobile') || '',
      sellerPhone: get(order, 'contact.sellerProfile.mobile') || '',
    }));

    const dataListNoZeroItems = dataList.filter(item => item.itemQty > 0);

    if (isPack) {
      return dataListNoZeroItems.sort((a, b) =>
        (a.buyerBusinessName && b.buyerBusinessName ?
          a.buyerBusinessName.localeCompare(b.buyerBusinessName) : 0),
      );
    }
    return dataListNoZeroItems.sort((a, b) =>
      (a.sellerBusinessName && b.sellerBusinessName ?
        a.sellerBusinessName.localeCompare(b.sellerBusinessName) : 0),
    );
  }

  updateCheck = (isChecked, index) => {
    const { checkUpdated } = this.props;
    checkUpdated(isChecked, index);
  }

  render() {
    const {
      isDistributor,
      isFarmer,
    } = this.context;
    const {
      deliveryDate,
      formatMessage,
      isPack,
      isPick,
      loading,
      printHeaderChecked,
    } = this.props;
    const listData = this.getListData(isPack);
    const info = [];
    let currentBuyerBusinessName = '';
    let currentSellerBusinessName = '';
    for (let i = 0; i < listData.length; i++) {
      if (isDistributor && isPack) {
        if (currentBuyerBusinessName === '') {
          currentBuyerBusinessName = listData[i].buyerBusinessName;
        }
        if (currentBuyerBusinessName !== listData[i].buyerBusinessName) {
          currentBuyerBusinessName = listData[i].buyerBusinessName;
          info.push({ itemName: '' });
        }
      } else if (isDistributor && !isPack) {
        if (currentSellerBusinessName === '') {
          currentSellerBusinessName = listData[i].sellerBusinessName;
        }
        if (currentSellerBusinessName !== listData[i].sellerBusinessName) {
          currentSellerBusinessName = listData[i].sellerBusinessName;
          info.push({ itemName: '' });
        }
      }

      if (isFarmer && isPack) {
        if (currentBuyerBusinessName === listData[i].buyerBusinessName) {
          listData[i].buyerBusinessName = '';
        }
        if (listData[i].buyerBusinessName) {
          currentBuyerBusinessName = listData[i].buyerBusinessName;
        }
      }
      info.push(listData[i]);
    }
    const fields = compact([
      isPack && {
        label: formatMessage('Customer Code'),
        name: 'buyerCompanyCode',
      },
      isPack && {
        label: formatMessage('Customer'),
        name: 'buyerBusinessName',
      },
      !isPack && {
        label: formatMessage('Vendor Code'),
        name: 'sellerCompanyCode',
      },
      !isPack && {
        label: formatMessage('Vendor'),
        name: 'sellerBusinessName',
      },
      {
        className: 'highlight',
        colSpan: 3,
        label: formatMessage('IN'),
        name: 'itemName',
      },
      {
        className: 'highlight',
        colSpan: 1,
        label: formatMessage('Tags'),
        name: 'itemTags',
      },
      {
        className: 'highlight',
        colSpan: 3,
        label: formatMessage('Description'),
        name: 'itemDescription',
      },
      {
        label: formatMessage('Qty'),
        name: 'itemQty',
      },
      {
        label: formatMessage('Pack-Out'),
        name: 'itemUom',
      },
      isPack && !isFarmer && {
        label: formatMessage('Vendor Code'),
        name: 'sellerCompanyCode',
        className: 'text-right',
      },
      isPack && !isFarmer && {
        label: formatMessage('Vendor'),
        name: 'sellerBusinessName',
      },
      isPick && {
        label: formatMessage('Customer Code'),
        name: 'buyerCompanyCode',
        className: 'text-right',
      },
      isPick && {
        label: formatMessage('Customer'),
        name: 'buyerBusinessName',
      },

      // !isPack && {
      //   label: formatMessage('Customer'),
      //   name: 'buyerBusinessName',
      // },
      isPack && {
        label: formatMessage('Delivery or Pick-Up'),
        name: 'deliveryType',
        render: row => (
          <div>{`${row.deliveryType === 1 ? 'Delivery' : row.deliveryType === 2 ? 'Pick-Up' : ''}`}</div>
        ),
      },
      isPack && {
        label: formatMessage('Location'),
        name: 'location',
        render: row => row.deliveryType === 1 ? (
          <div>
            {[
            row.buyerAddress.address,
            row.buyerAddress.city,
            row.buyerAddress.state && row.buyerAddress.zipcode
                ? `${row.buyerAddress.state || ''} - ${row.buyerAddress.zipcode ||
                    ''}`
                : '',
            ].join(', ')}
            {`. ${formatMessage('Phone')}: ${formatPhoneNumber(row.buyerPhone) || ''}.`}
          </div>
        ) :  row.deliveryType === 2 && (
          <div>
            {[
            row.sellerAddress.address,
            row.sellerAddress.city,
            row.sellerAddress.state && row.sellerAddress.zipcode
                ? `${row.sellerAddress.state || ''} - ${row.sellerAddress.zipcode ||
                    ''}`
                : '',
            ].join(', ')}
            {`. ${formatMessage('Phone')}: ${formatPhoneNumber(row.sellerPhone) || ''}.`}
          </div>
        ),
      },
    ]);
    const packListHeader = `${formatMessage(`${isDistributor ? 'Customer Pack Lists' : 'Pack-list'} for`)} ${moment(deliveryDate).format('LLLL')}`;
    const pickListHeader = `${formatMessage(`${isDistributor ? 'Vendor Pick Lists' : 'Purchase orders'} for`)} ${moment(deliveryDate).format('LLLL')}`;
    return (
      <div>
        {
          loading && (
            <div className="print-progress">
              <CircularProgress />
            </div>
          )
        }
        {isPack || (!isFarmer && !isPack) ?
          (
            <div>
              <div className="packlist-header">{isPack ? packListHeader : pickListHeader}</div>
              <div className="checked-list">
                {
                  fields.map((field, index) => (
                    <span key={index}>
                      <Checkbox
                        checked={printHeaderChecked[index]}
                        onChange={(e, isInputChecked) => this.updateCheck(isInputChecked, index)}
                      />
                      {field.label}
                    </span>
                  ))
                }
              </div>
              <PrintableTable
                checkedArray={printHeaderChecked}
                data={info}
                fields={fields}
              />
            </div>
          ) : ''
        }
      </div>
    );
  }
}

const wrappedPackListPrint = injectIntl(PackListPrint);
wrappedPackListPrint.displayName = 'PackListPrint';

export default wrappedPackListPrint;
